import { z } from "zod";

// The 5 supported app locales. Single source of truth for both the type
// and the runtime list.
//
// `Locale` used to be declared in ./descriptions.ts, the module that
// also parses the bundled exercise-description JSON at import time. That
// put the type behind a side-effecting module and made any file needing
// only the type pull the JSON in with it. It lives here now, next to
// the list and the coercion helper; ./descriptions.ts imports it back.
export const Locale = z.enum(["en", "it", "fr", "de", "ru"]);
export type Locale = z.infer<typeof Locale>;

export const SUPPORTED_LOCALES: readonly Locale[] = [
  "en",
  "it",
  "fr",
  "de",
  "ru",
];

// Normalise an i18n language tag (e.g. "fr-CH", "de", undefined) to a
// supported `Locale`, falling back to "en". Replaces the 5-line `langOf`/
// `coerceLocale` helper that was copy-pasted across screens (audit
// 2026-06-03). Splits on "-" so region subtags resolve to their base lang.
export function coerceLocale(raw: string | undefined): Locale {
  const head = (raw?.split("-")[0] ?? "en").toLowerCase();
  return (SUPPORTED_LOCALES as readonly string[]).includes(head)
    ? (head as Locale)
    : "en";
}
